import {
  AnyUserEntityVersion,
  Collections,
  FirestoreEntity,
  Mapper,
  User,
} from '@uploadcam/common';
import { CollectionReference, Firestore, getDocs, query, where } from 'firebase/firestore';
import { GetUserInteractor } from '../../../auth/domain/interactors/get-user.interactor';
import invariant from 'tiny-invariant';
import { getCollectionRef } from '../../../../@harmony/angular';

export class GetTeamUsersInteractor {
  private readonly collection: CollectionReference<AnyUserEntityVersion>;

  constructor(
    private readonly db: Firestore,
    private readonly getUser: GetUserInteractor,
    private readonly mapper: Mapper<FirestoreEntity<AnyUserEntityVersion>, User>,
  ) {
    this.collection = getCollectionRef(this.db, Collections.Users);
  }

  public async execute(teamId?: string): Promise<User[]> {
    if (!teamId) {
      const user = await this.getUser.execute();
      invariant(user.teamId, 'The user must be part of a team');

      teamId = user.teamId;
    }

    const teamUsersQuery = query(this.collection, where('teamId', '==', teamId));
    const teamUsersDocs = await getDocs(teamUsersQuery);

    return teamUsersDocs.docs.map((doc) => this.mapper.map(FirestoreEntity.from(doc)));
  }
}
